// extracted by mini-css-extract-plugin
export default {"AccountLabel":"rMCSbqSrcOYvMs_Az81g","ChangeButton":"le179CH1gvIYGQd_ABrG","SaveButton":"jOzvOq1dXrUO4wicOCQz","Status":"g2IqphAXsgfYiIAmbeiP"};